import { ICategoryOfferingsMap, ISubCategory, OfferingsSubCategory } from './../../api/models/api-models';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable()
export class CategoriesService {
  constructor(public http: HttpClient) {}

  public getCategoriesOfferingsMap(): Observable<ICategoryOfferingsMap[]> {
    return this.http.get('assets/categories/category-offerings.json').pipe(
      map((response: any) => {
        return response.categoriesOfferingsMapArray;
      })
    );
  }

  public getOfferingsSubCategories(): Observable<Map<OfferingsSubCategory, ISubCategory>> {
    return this.http
      .get('assets/categories/offerings-subcategories.json')
      .pipe(map((response: any) => response as Map<OfferingsSubCategory, ISubCategory>));
  }

  public getServices(): Observable<string[]> {
    return this.http.get('assets/categories/services.json').pipe(map((response: any) => response.services));
  }

  public getPayments(): Observable<string[]> {
    return this.http.get('assets/categories/payment-methods.json').pipe(map((response: any) => response.payments));
  }
}
